import React from 'react'
import OneColWrapper from '../technical/OneColWrapper'
import ModalRegistration from 'gatsby-theme-kn/src/components/modules/ModalRegistration'

const RegistrationButtonBlock = ({ block }) => {
  return (
    <OneColWrapper block={block}>
      <ModalRegistration buttonTitle={block.title} />
    </OneColWrapper>
  )
}

export default RegistrationButtonBlock
